<template>
    <v-form v-on:submit.prevent="onSubmit" ref="form" :class="[isThemeAja ? 'theme-aja' : '', 'mt-3']">
        <v-row v-if="cannotEdit">
             <v-col cols="12">
                <v-radio-group v-model="meeting.type" row class="ml-4">
                    <span class="mr-6"> Mode : </span>
                    <v-radio disabled :active-class="workshop.type =='remote'" label="Visio" value="remote" ></v-radio>
                    <v-radio disabled label="Présentiel" value="onsite" ></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="12" :md="4">
                <v-text-field
                    :value="formattedMeetingDate"
                    label="Date"
                    disabled
                    outlined
                    hide-details
                ></v-text-field>
            </v-col>
            <v-col cols="12" :md="4">
                <v-text-field
                    v-model="startTime"
                    label="Heure de début"
                    disabled
                    outlined
                    hide-details
                ></v-text-field>
            </v-col>
            <v-col cols="12" :md="4">
                <v-text-field
                    v-model="endTime"
                    label="Heure de fin"
                    disabled
                    outlined
                    hide-details
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12">
             <v-radio-group v-model="meeting.type" row class="ml-4">
                 <span class="mr-6"> Mode : </span>
                <v-radio color="primary" label="Visio" value="remote" ></v-radio>
                <v-radio color="primary" :disabled="workshop.type =='remote'" label="Présentiel" value="onsite" ></v-radio>
            </v-radio-group>
            </v-col>
            <v-col cols="12" :md="4">
                <v-menu
                    v-model="menu_meeting_date"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    color="primary"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="formattedMeetingDate"
                            label="Date"
                            readonly
                            v-on="on"
                            outlined
                            hide-details
                            :rules="[rules.required]"
                            color="primary"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        @input="menu_meeting_date = false"
                        locale="fr-FR"
                        :min="$moment().add(1, 'd').format('YYYY-MM-DD')"
                        color="primary"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" :md="4">
                <v-menu
                    ref="menuStart"
                    v-model="menu_meeting_start"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="startTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    color="primary"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="startTime"
                            label="Heure de début"
                            readonly
                            v-on="on"
                            outlined
                            hide-details
                            :rules="[rules.required]"
                            color="primary"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="menu_meeting_start"
                        v-model="startTime"
                        full-width
                        @click:minute="$refs.menuStart.save(startTime)"
                        format="24hr"
                        :max="endTime"
                        color="primary"
                    ></v-time-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" :md="4">
                <v-menu
                    ref="menuEnd"
                    v-model="menu_meeting_end"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="endTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    color="primary"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="endTime"
                            label="Heure de fin"
                            readonly
                            v-on="on"
                            outlined
                            hide-details
                            :rules="[rules.required]"
                            color="primary"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="menu_meeting_end"
                        v-model="endTime"
                        full-width
                        @click:minute="$refs.menuEnd.save(endTime)"
                        format="24hr"
                        :min="startTime"
                        color="primary"
                    ></v-time-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-text-field
                    v-model="meeting.sequence"
                    :loading="sequenceLoading"
                    outlined
                    label="Identifiant de séquence"
                    color="primary"
                    :rules="[rules.required]"
                    :persistent-hint="isOncommenceWorkshop"
                ></v-text-field>
            </v-col>
            <v-col>
                <v-text-field
                    v-model="meeting.places"
                    outlined
                    label="Nombre de place"
                    :rules="[rules.required, rules.min1]"
                    color="primary"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-textarea
                    v-if="meeting.type == 'remote'"
                    v-model="meeting.link"
                    outlined
                    auto-grow
                    label="Lien"
                    hide-details
                    color="primary"
                ></v-textarea>
                <v-textarea
                    v-if="meeting.type == 'onsite'"
                    v-model="meeting.address"
                    outlined
                    auto-grow
                    label="Adresse"
                    hide-details
                    color="primary"
                ></v-textarea>
            </v-col>
        </v-row>

        <v-row class="mt-6">
            <v-col>
                <v-autocomplete
                    v-model="meeting.subscribers"
                    :items="proposedSubscribers"
                    @change="checkUsers('subscribers')"
                    item-text="complete_name"
                    item-value="id"
                    label="Ajouter / supprimer des participants"
                    multiple
                    chips
                    deletable-chips
                    hint="Veuillez sélectionner les participants à cette séance"
                    :search-input.sync="subscribersQuery"
                    :counter="meeting.places"
                    :error-messages="errorPlaces"
                    :loading="loadingUser"
                    no-filter
                    return-object
                    color="primary"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-autocomplete
                    v-model="meeting.queued"
                    :items="proposedQueued"
                    @change="checkUsers('queued')"
                    item-text="complete_name"
                    item-value="id"
                    label="Liste d'attente"
                    multiple
                    chips
                    deletable-chips
                    hint="Veuillez sélectionner les bénéficiaires en attente"
                    :search-input.sync="queuedQuery"
                    :loading="loadingUser"
                    no-filter
                    return-object
                    color="primary"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row justify="center" class="mt-5">
            <v-btn @click.stop="cancel" text color="secondary">Annuler</v-btn>
            <v-btn color="primary" type="submit" :disabled="loading" :loading="loading">Sauvegarder</v-btn>
        </v-row>

        <!-- Dialog de confirmation pour les désinscriptions -->
        <v-dialog v-model="dialogConfirmUnsubscriptions" max-width="650" persistent>
            <v-card>
                <v-card-title :class="isAjaMeeting ? 'aja-header white--text' : 'primary white--text'">
                    <v-icon left color="white">warning</v-icon>
                    Participants retirés de la séance
                </v-card-title>
                <v-card-text class="pt-4">
                    <p>Les participants suivants vont être désinscrits :</p>
                    <div class="mb-4">
                        <v-chip
                            v-for="user in removedSubscribers"
                            :key="user.id"
                            class="ma-1"
                            small
                            :color="isAjaMeeting ? '#4E983C' : 'primary'"
                            text-color="white"
                        >
                            {{ user.complete_name }}
                        </v-chip>
                    </div>

                    <v-divider class="my-4"></v-divider>

                    <p class="subtitle-1 font-weight-medium">
                        Ces désinscriptions doivent-elles être comptabilisées dans leur quota ?
                    </p>

                    <v-radio-group v-model="unsubscriptionsLegitimate" class="mt-2">
                        <v-radio
                            :value="true"
                            color="success"
                        >
                            <template v-slot:label>
                                <div>
                                    <strong class="success--text">Non, désinscriptions légitimes</strong>
                                    <div class="caption grey--text">
                                        Les séances ne seront pas comptabilisées dans le quota
                                        (ex: annulation de la séance par l'organisation)
                                    </div>
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            :value="false"
                            color="warning"
                        >
                            <template v-slot:label>
                                <div>
                                    <strong class="warning--text">Oui, désinscriptions tardives</strong>
                                    <div class="caption grey--text">
                                        Les séances seront comptabilisées comme annulations tardives
                                    </div>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn text @click="cancelUnsubscriptions">Annuler</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="unsubscriptionsLegitimate ? 'success' : 'warning'"
                        @click="confirmUnsubscriptions"
                        :loading="loading"
                    >
                        Confirmer et sauvegarder
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        value: Object,
        workshop: Object,
    },
    data () {
        return {
            loading: false,
            rules: {
                required: value => !!value || 'Champ requis',
                min1: value => !value || (value && value >= 1) || 'supérieur ou égale à 1',
                max200: value => !value || (value && value <= 200) || 'inférieur ou égale à 200',
            },
            menu_meeting_date: false,
            menu_meeting_start: false,
            menu_meeting_end: false,
            meeting: Object.assign({}, this.value),
            date: '',
            startTime: '',
            endTime: '',
            proposedSubscribers: [],
            proposedQueued: [],
            loadingUser: false,
            cannotEdit: false,
            errorPlaces: [],
            subscribersQuery: '',
            queuedQuery: '',
            search: {},
            sequenceLoading: false,
            // Unsubscription confirmation dialog
            dialogConfirmUnsubscriptions: false,
            removedSubscribers: [],
            originalSubscriberIds: [],
            unsubscriptionsLegitimate: true, // Default: legitimate (no penalty)
            pendingFormData: null,
        }
    },
    computed: {
        ...mapGetters(['isThemeAja']),
        formattedMeetingDate () {
            return this.date ? this.$moment(this.date).format('DD/MM/YYYY') : ''
        },
        isAjaMeeting() {
            return this.workshop.is_aja
        },
        isOncommenceWorkshop() {
            return this.workshop.workshop_type === 'oncommence'
        },
    },
    watch: {
        meeting: {
            handler() {
                if (this.meeting.id) {
                    this.date = this.$moment(this.meeting.start).format('YYYY-MM-DD')
                    this.startTime = this.$moment(this.meeting.start).format('HH:mm')
                    this.endTime = this.$moment(this.meeting.end).format('HH:mm')

                    this.errorPlaces = []
                    if (this.meeting.subscribers.length > this.meeting.places)
                        this.errorPlaces = ['Le nombre de participants dépasse le nombre de place limite']
                }
            },
            immediate: true,
            deep: true,
        },
        subscribersQuery: {
            async handler(){
                this.proposedSubscribers = this.meeting.subscribers
                // fetch only if 1 character min
                if (this.subscribersQuery && this.subscribersQuery.length > 0) {
                    this.search.name = this.subscribersQuery
                    const fetchUsersResult = await this.fetchUsers()
                    this.proposedSubscribers = this.meeting.subscribers.concat(fetchUsersResult)
                }
            }
        },
        queuedQuery: {
            async handler(){
                this.proposedQueued = this.meeting.queued
                // fetch only if 1 character min
                if (this.queuedQuery && this.queuedQuery.length > 0) {
                    this.search.name = this.queuedQuery
                    const fetchUsersResult = await this.fetchUsers()
                    this.proposedQueued = this.meeting.queued.concat(fetchUsersResult)
                }
            }
        },
        date() {
            this.getSequenceNumber()
        }
    },
    mounted() {
        if(!this.meeting.id && this.workshop.start && this.workshop.end) {
            this.startTime =  this.$moment(this.workshop.start, "HH:mm:ss").format('HH:mm')
            this.endTime = this.$moment( this.workshop.end, "HH:mm:ss").format('HH:mm')
        }

        // Pré-remplir la séquence "oncommence" pour les nouveaux ateliers ONCO'MMENCE
        if (!this.meeting.id && this.isOncommenceWorkshop) {
            this.meeting.sequence = 'oncommence'
        }

        // this.fetchUsers()
        this.proposedSubscribers = this.meeting.subscribers
        this.proposedQueued = this.meeting.queued

        // Store original subscriber IDs for comparison on save
        this.originalSubscriberIds = this.meeting.subscribers.map(s => s.id)

        // if editing && already subscribers, cannotEdit = true
        this.cannotEdit = this.meeting.id && this.meeting.subscribers.length > 0
    },
    methods: {
        onSubmit () {
            if(this.meeting.type == "remote" && !this.meeting.link) {
                this.$store.commit('setSnack', {'type': 'error', 'msg': 'Merci de renseigner le lien zoom'})
                return
            }
            if(this.meeting.type == "onsite" && !this.meeting.address) {
                this.$store.commit('setSnack', {'type': 'error', 'msg': 'Merci de renseigner l\'adresse'})
                return
            }
            if (this.$refs.form.validate() && //empeche l'envoie de la requette si pas assez de places
            ((this.meeting.subscribers.length < this.meeting.places) || (this.meeting.subscribers.length == this.meeting.places) )) {

                // Check if this is an edit with removed subscribers
                if (this.meeting.id && this.originalSubscriberIds.length > 0) {
                    const currentSubscriberIds = this.meeting.subscribers.map(s => s.id)
                    const removedIds = this.originalSubscriberIds.filter(id => !currentSubscriberIds.includes(id))

                    if (removedIds.length > 0) {
                        // Find the removed subscribers for display
                        this.removedSubscribers = this.proposedSubscribers.filter(s => removedIds.includes(s.id))

                        // If we couldn't find them in proposedSubscribers, create placeholder objects
                        if (this.removedSubscribers.length === 0) {
                            this.removedSubscribers = removedIds.map(id => ({
                                id: id,
                                complete_name: `Utilisateur #${id}`
                            }))
                        }

                        // Store the form data for later submission
                        this.pendingFormData = this.prepareFormData()
                        this.unsubscriptionsLegitimate = true // Default: legitimate
                        this.dialogConfirmUnsubscriptions = true
                        return
                    }
                }

                // No removed subscribers, submit directly
                this.submitForm(null)
            }
        },
        prepareFormData() {
            // format start/end
            const formData = Object.assign({}, this.meeting)
            formData.start = this.date + ' ' + this.startTime + ':00'
            formData.end = this.date + ' ' + this.endTime + ':00'

            if (! formData.workshop_id)
                formData.workshop_id = this.workshop.id

            let request = 'meetingCreateRequest'
            let queries = formData

            if (this.meeting.id) {
                request = 'meetingEditRequest'
                queries = {id: this.meeting.id, datas: formData}
                // format subscribers
                queries.datas.subscribers = queries.datas.subscribers.map((sub) => sub.id)
                queries.datas.queued = queries.datas.queued.map((sub) => sub.id)
            }

            return { request, queries }
        },
        submitForm(isLegitimate) {
            this.loading = true

            const { request, queries } = this.pendingFormData || this.prepareFormData()

            // Add is_legitimate parameter if specified
            if (isLegitimate !== null && request === 'meetingEditRequest') {
                queries.datas.is_legitimate = isLegitimate
            }

            this.$store.dispatch(request, queries)
                .then((meeting) => {
                    this.loading = false
                    this.$store.commit('setSnack', {'type': 'success', 'msg': 'Séance enregistrée !'})
                    this.$emit('savedForm', meeting)
                })
                .catch((err) => {
                    this.loading = false
                    if (err.response.status != 403)
                        this.$store.dispatch('setErrors', err.response.data)
                })
        },
        cancelUnsubscriptions() {
            this.dialogConfirmUnsubscriptions = false
            this.removedSubscribers = []
            this.pendingFormData = null
            this.unsubscriptionsLegitimate = true
        },
        confirmUnsubscriptions() {
            this.dialogConfirmUnsubscriptions = false
            this.submitForm(this.unsubscriptionsLegitimate)
        },
        cancel() {
            this.$emit('canceledForm');
        },
        fetchUsers() {
            this.loadingUser = true
            this.search.role = 'user'
            let queries = {
                search: JSON.stringify({...this.search, is_archived: false}),
                per_page: 5
            }
            let users = []
            return this.$store.dispatch('usersRequest', queries)
                .then((result) => {
                    users = result.data
                    return users
                }).catch((err) => {

                })
                .finally(() => {
                    this.search.name = null
                    this.loadingUser = false
                    return users
                })
        },
        checkUsers(field) {
            if (field == 'queued'){
                this.meeting.subscribers = this.meeting.subscribers.filter((u) => {
                    return this.meeting.queued.filter((q) => q.id == u.id).length == 0
                })
            }
            if (field == 'subscribers'){
                this.meeting.queued = this.meeting.queued.filter((u) => {
                    return this.meeting.subscribers.filter((sub) => sub.id == u.id).length == 0
                })
            }
        },
        getSequenceNumber() {
            if(!this.date) return

            // Pour les ateliers ONCO'MMENCE, la séquence est toujours "oncommence"
            if (this.isOncommenceWorkshop) {
                this.meeting.sequence = 'oncommence'
                return
            }

            this.meeting.sequence = null
            this.sequenceLoading = true

            // Get the week number and year using moment
            const momentDate = this.$moment(this.date)
            const weekNumber = momentDate.isoWeek()
            const year = momentDate.isoWeekYear()

            this.$store.dispatch('planningSequenceRequest', {
                workshop_id: this.workshop.id,
                weekNumber: weekNumber,
                year: year,
            })
            .then(result => {
                this.meeting.sequence = result.data
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                this.sequenceLoading = false
            })
        }
    }
}
</script>

<style>
/* Change the selected item color when isThemeAja is true */
.theme-aja .v-chip {
    background-color: var(--v-primary-base) !important;
    color: #fff !important;
}

.aja-header {
    background-color: #4E983C !important;
}
</style>
